import React, { Fragment, useState } from 'react';
import {
    Collapse,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListSubheader,
    makeStyles
} from '@material-ui/core';
import {Link, Match} from "@reach/router";

import SendIcon from '@material-ui/icons/Send';
import {gql} from "apollo-boost";
import {useQuery} from "@apollo/react-hooks";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HomeIcon from '@material-ui/icons/Home';
import AssignmentIcon from '@material-ui/icons/Assignment';
import NavigationListMap from '../utils/NavigationListMap';
import theme from '../styles/theme';

const useNavigationStyles = makeStyles({
    root: {
        width: '100%',
        minWidth: 240,
        maxWidth: 240,
        paddingTop: 0,
        paddingBottom: 0,
        borderTop: '1px solid rgba(0,0,0,0.3)',
    },
    list: {
        '& .MuiListItem-root': {
            borderBottom: '1px solid rgba(0,0,0,0.3)',
            paddingLeft: '20px'
        }
    },
    expandIcon: {
        transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        transform: 'rotate(0deg)',

        '&.expanded': {
            transform: 'rotate(180deg)',
        }
    }
});

export const MainListItems = ({ drawerOpen, handleDrawerOpen, }) => {
    const [selectedIndex, setSelectedIndex] = useState('');
    const navClasses = useNavigationStyles();
    const handleClick = (idx) => {
        if (selectedIndex === idx) {
            setSelectedIndex('')
        } else {
            handleDrawerOpen();
            setSelectedIndex(idx)
        }
    }

    const {data} = useQuery(gql`
        query isAuthorized {
            isAuthorized
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });

    if (data && data.isAuthorized) {
        return (
            <Fragment>
                {NavigationListMap.map((item, idx) => {
                    return (
                        <List key={idx.toString()} className={navClasses.root}>
                            <ListItem button onClick={() => {
                                if (item.arr.length) {
                                    handleClick(idx.toString());
                                }
                                if (item.path.length) {
                                    window.location = `/info/${item.path}`;
                                }
                            }}>
                                <ListItemIcon>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText primary={item.title} />
                                {item.arr.length ? (
                                    <ExpandMoreIcon
                                      className={navClasses.expandIcon + `${idx.toString() === selectedIndex ? ' expanded' : ''}`}
                                    />
                                ) : null}
                            </ListItem>
                            <Collapse in={idx.toString() === selectedIndex} timeout='auto' unmountOnExit>
                                <List component='div' disablePadding className={navClasses.list}>
                                    {item.arr.map((itemLink, linkIdx) => (
                                        <ListItem button component={Link} to={itemLink.path} key={itemLink.path}>
                                           <ListItemText primary={itemLink.title}/>
                                       </ListItem>
                                    ))}
                                </List>
                            </Collapse>
                        </List>
                    )
                })}
            </Fragment>
        )
    }

    return <div className={navClasses.root}>
        <Match path="/info">
            {matchProps =>
                <ListItem button component={Link} to="/info" selected={!!matchProps.match}>
                    <ListItemIcon>
                        <HomeIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Home"/>
                </ListItem>
            }
        </Match>
        <Match path="posting">
            {matchProps =>
                <ListItem button component={Link} to="posting" selected={!!matchProps.match}>
                    <ListItemIcon>
                        <SendIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Posting Instructions"/>
                </ListItem>
            }
        </Match>
        <Match path="offer-event-api-posting">
            {matchProps =>
                <ListItem button component={Link} to="offer-event-api-posting" selected={!!matchProps.match}>
                    <ListItemIcon>
                        <SendIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Offer Event API Posting Instructions"/>
                </ListItem>
            }
        </Match>
        <Match path="lead-purchase-posting">
            {matchProps =>
                <ListItem button component={Link} to="lead-purchase-posting" selected={!!matchProps.match}>
                    <ListItemIcon>
                        <SendIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Lead Purchase Posting Instructions"/>
                </ListItem>
            }
        </Match>
        <Match path="lead-purchase-v2-posting">
            {matchProps =>
                <ListItem button component={Link} to="lead-purchase-v2-posting" selected={!!matchProps.match}>
                    <ListItemIcon>
                        <SendIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Lead Purchase v2 Posting Instructions"/>
                </ListItem>
            }
        </Match>
        <Match path="list-management-posting">
            {matchProps =>
                <ListItem button component={Link} to="list-management-posting" selected={!!matchProps.match}>
                    <ListItemIcon>
                        <SendIcon/>
                    </ListItemIcon>
                    <ListItemText primary="List Management Posting Instructions"/>
                </ListItem>
            }
        </Match>
    </div>
};

export const SecondaryListItems = () => {
    const {data} = useQuery(gql`
        query isAuthorized {
            isAuthorized
        }
    `, {context: {clientName: 'endpoint2'}});
    if (data && data.isAuthorized) return (
        <div>
            <ListSubheader>Reports</ListSubheader>
            <ListItem button>
                <ListItemIcon>
                    <AssignmentIcon/>
                </ListItemIcon>
                <ListItemText primary="Current month"/>
            </ListItem>
            <ListItem button>
                <ListItemIcon>
                    <AssignmentIcon/>
                </ListItemIcon>
                <ListItemText primary="Last quarter"/>
            </ListItem>
            <ListItem button>
                <ListItemIcon>
                    <AssignmentIcon/>
                </ListItemIcon>
                <ListItemText primary="Year-end sale"/>
            </ListItem>
        </div>
    );
    return null;
};
